import type { IStatBucket } from '@platform/core/types';
import type { DesignSectionKey } from './DesignSectionKey';

/** Види записів аналізу, які рахує пункт меню розділу (прототип v4 mdItems: «Зацікавлені сторони» — кількість потреб модуля). */
const COUNTED: Record<Exclude<DesignSectionKey, 'journeys' | 'model'>, string[]> = {
  features: ['Feature'], motivation: ['Problem', 'Risk', 'Opportunity'], stakeholders: ['Stakeholder need'], useCases: ['Use case'], requirements: ['Requirement'],
};

/**
 * Лічильники пунктів «Проєктування» (прототип v4 mdItems): з відер статистики записів аналізу модуля за видом, кількості наскрізних шляхів,
 * що згадують модуль, і кількості типів записів модуля (модель даних). Undefined — статистика ще вантажиться. Чиста функція.
 */
export function designCountsOf(byKind: IStatBucket[] | undefined, journeys: number | undefined, entities: number): Record<DesignSectionKey, number | undefined> {
  const sum = (kinds: string[]) => (byKind ? byKind.filter((b) => b.value !== null && kinds.includes(b.value)).reduce((n, b) => n + b.count, 0) : undefined);
  return {
    features: sum(COUNTED.features), motivation: sum(COUNTED.motivation), stakeholders: sum(COUNTED.stakeholders), journeys,
    useCases: sum(COUNTED.useCases), requirements: sum(COUNTED.requirements), model: entities,
  };
}
